module.exports = __webpack_public_path__ + "static/Group 3 Copy@2x-50bdc29cfb4146d048d8c05db655d721.png";